export const compareValues = (a, b) => {
  if (a == null) return -1;
  if (b == null) return 1;
  if (typeof a === 'number' && typeof b === 'number') return a - b;
  return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
};

/**
 * Client-side sort for DataTable row objects ({ rowData, ... }).
 * @param {Array} rows
 * @param {{ name: string|null, direction: 'asc'|'desc' }} sort
 * @param {Array} columns - column definitions (sortable, sortValue, name)
 */
export const sortClientRows = (rows, sort, columns = []) => {
  if (!sort?.name) return rows;
  const column = columns.find((col) => col.name === sort.name);
  if (!column) return rows;

  const accessor = (row) => {
    if (typeof column.sortValue === 'function') return column.sortValue(row.rowData, row);
    const value = row.rowData ? row.rowData[column.name] : undefined;
    return typeof value === 'function' ? undefined : value;
  };

  const next = [...rows].sort((a, b) => compareValues(accessor(a), accessor(b)));
  return sort.direction === 'desc' ? next.reverse() : next;
};

export const paginateRows = (rows, page, pageSize) => {
  const start = (page - 1) * pageSize;
  return rows.slice(start, start + pageSize);
};
